export const whatsWrongData = {
  title: "What's wrong with your car?",
  imgObj: {
    src: 'https://media.product.which.co.uk/prod/images/original/9fed45f32d33-tooliconbrokencar.jpg',
    alt: '',
  },
  note: ['Insert details on the issue into the sentence below.', 'The vehicle has...'],
  descriptiveText: [],
  placeholderText: 'Eg. developed a fault with the engine.',
}
